import React from 'react'
import PropTypes from 'prop-types'
import Svg from '../shared/Svg'

const SEARCH_FILL = '#4A4A4A'

const Search = (props, { fill = SEARCH_FILL }) => (
  <Svg
    width="14px"
    height="15px"
    viewBox="0 0 14 15"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-332.000000, -216.000000)" fill={fill} fillRule="nonzero">
        <g transform="translate(308.000000, 94.000000)">
          <g transform="translate(24.000000, 117.000000)">
            <g>
              <path
                d="M11.2726608,15.4403164 L13.5845459,18.1955138 C13.9744848,18.6602249 13.91387,19.3530555 13.4491589,19.7429944 C12.9844479,20.1329333 12.2916172,20.0723185 11.9016783,19.6076074 L9.5995264,16.8640096 C8.6527418,17.4216998 7.5491294,17.7416004 6.3708002,17.7416004 C2.8523044,17.7416004 0,14.889296 0,11.3708002 C0,7.8523044 2.8523044,5 6.3708002,5 C9.88929599,5 12.7416004,7.8523044 12.7416004,11.3708002 C12.7416004,12.9181193 12.1899784,14.3366002 11.2726608,15.4403164 Z M6.3708002,14.8857244 C8.31203926,14.8857244 9.88572445,13.3120393 9.88572445,11.3708002 C9.88572445,9.42956114 8.31203926,7.85587595 6.3708002,7.85587595 C4.42956114,7.85587595 2.85587595,9.42956114 2.85587595,11.3708002 C2.85587595,13.3120393 4.42956114,14.8857244 6.3708002,14.8857244 Z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Svg>
)

Search.defaultProps = {
  fill: SEARCH_FILL,
}

Search.propTypes = {
  fill: PropTypes.string,
}

export default Search
